import { closeUploadModal } from '../State/uploadModal'

export default () => (dispatch) => {

  dispatch(closeUploadModal())
  
}
